export const nav = {
    p1: `Você pode gerenciar suas informações pessoais, alterar sua senha, integrações, assinatura e ajustar suas preferências de usuário`,
    p2: `Minha conta`,
    p3: `Configure os detalhes da sua acomodação, personalize mensagens de boas-vindas, políticas, conecte-se com as autoridades locais para o envio automático de relatórios de viajantes e ajuste as preferências operacionais`,
    p4: `Configurações da acomodação`,
    p5: `Gerencie e promova os serviços adicionais da sua acomodação, como aluguel de espaços, passeios e outros extras, para melhorar a experiência dos seus hóspedes e aumentar sua receita`,
    p6: `Vendas cruzadas`,
    p7: `Criar nova acomodação`,
    p8: `E-mail de confirmação enviado com sucesso`,
    p9: `Acomodações`,
    p10: ``,
    p11: ``,
    p12: ``,
    p13: ``,
    p14: ``,
    p15: ``,
    p16: ``,
    p17: ``,
    p18: ``,
    p19: ``,
    p20: ``,
    p21: ``,
    p22: ``,
    p23: ``,
};
